<template>
  <div class="publicSubmit">
    <!-- <app-header :disablejump="true"></app-header> -->
    <div class="login-container">
      <div class="container clearfix">
        <div class="loginBox">
          <el-form
            autocomplete="on"
            :model="loginForm"
            :rules="loginRules"
            ref="loginForm"
            label-position="left"
          >
            <div class="loginForm">
              <div class="head">
                <a class="active" @click="handleLogins">账号登录</a>
                <!-- <a  style="color:#000" @click="handleQuickLogin">手机快捷登录</a> -->
              </div>

              <div class="content">
                <div id="login">
                  <div class="form-group">
                    <div class="form-group">
                      <div class="input-group">
                        <svg aria-hidden="true" class="icon input-group-text">
                          <use xlink:href="#icon-name">
                            <svg
                              id="icon-name"
                              viewBox="0 0 1024 1024"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M870.410034 772.355608c-19.685219-46.668693-48.021246-88.545603-83.957573-124.488073-35.941447-35.936327-77.818356-64.164846-124.487049-83.956549-0.416721-0.209896-0.833443-0.317404-1.251188-0.525253 64.898971-46.876542 107.091238-123.234838 107.091238-209.385573 0-142.71016-115.631465-258.34265-258.347769-258.34265-142.712208 0-258.343674 115.632489-258.343674 258.34265 0 86.151759 42.187147 162.509031 107.086119 209.493081-0.416721 0.207849-0.833443 0.311261-1.251188 0.520134-46.668693 19.689315-88.545603 47.918857-124.48193 83.961668-35.94247 35.94247-64.170989 77.81938-83.962692 124.488073-19.373958 45.626378-29.690627 94.064345-30.732942 143.854864-0.102389 4.691443 3.64708 8.547395 8.336474 8.547395h62.50308a8.314973 8.314973 0 0 0 8.332378-8.128626c2.085654-80.416977 34.380021-155.732958 91.465724-212.819684 59.064873-59.063849 137.50268-91.566065 221.049675-91.566064 83.545971 0 161.989921 32.502216 221.052746 91.566064 57.08775 57.08775 89.382117 132.402707 91.461628 212.819684 0.106484 4.582911 3.748444 8.128626 8.337498 8.128626h62.50308c4.684275 0 8.43272-3.855952 8.332379-8.547395-1.045387-49.790519-11.355912-98.22951-30.736014-143.962372zM509.457693 533.17702c-47.813397 0-92.813157-18.645976-126.668949-52.501768s-52.502792-78.856576-52.502792-126.675092c0-47.811349 18.647-92.812133 52.502792-126.667925s78.856576-52.501768 126.668949-52.501768c47.817492 0 92.818276 18.645976 126.674068 52.501768 33.855792 33.855792 52.502792 78.856576 52.502792 126.667925 0 47.818516-18.647 92.8193-52.502792 126.675092s-78.856576 52.501768-126.674068 52.501768z m0 0"
                              />
                            </svg>
                          </use>
                        </svg>

                        <el-form-item prop="username">
                          <input
                            name="username"
                            type="text"
                            v-model="loginForm.username"
                            autocomplete="on"
                            placeholder="请输入用户名/手机"
                            class="form-control ui-input"
                          />
                        </el-form-item>
                      </div>
                      <div class="help-block"></div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text">
                        <use xlink:href="#icon-pass">
                          <svg
                            id="icon-pass"
                            viewBox="0 0 1024 1024"
                            width="100%"
                            height="100%"
                          >
                            <path
                              d="M611.139744 96.566721c-174.373814 0-315.720159 141.346345-315.720159 315.720159 0 73.013263 24.823076 140.204713 66.365175 193.689411l-42.683731 42.687827-64.702386-64.701362c-3.220119-3.220119-8.518726-3.220119-11.841233 0l-41.333227 41.334251c-3.221143 3.221143-3.221143 8.513606 0 11.836114l64.700337 64.701362-46.631833 46.633881-64.702385-64.701362c-3.221143-3.220119-8.51463-3.220119-11.835091 0l-41.33425 41.334251c-3.221143 3.221143-3.221143 8.515654 0 11.841233l64.701361 64.701362-67.822164 67.814997c-3.220119 3.220119-3.220119 8.518726 0 11.734749l43.931848 43.9298c3.221143 3.221143 8.51975 3.221143 11.733726 0L417.348969 661.748348c53.586062 41.441759 120.783656 66.258691 193.791799 66.258691 174.374838 0 315.725279-141.345321 315.725279-315.720159 0-174.373814-141.351465-315.720159-315.726303-315.720159z m167.417538 483.136672c-44.655735 44.764266-104.164974 69.37847-167.417538 69.37847-63.24642 0-122.755659-24.614203-167.411394-69.37847-44.762219-44.654711-69.377446-104.164974-69.377445-167.416513 0-63.24642 24.615227-122.755659 69.377445-167.416513 44.655735-44.757099 104.164974-69.371302 167.411394-69.371303 63.25154 0 122.760779 24.615227 167.417538 69.371303 44.762219 44.661878 69.377446 104.170093 69.377445 167.416513 0 63.25154-24.615227 122.761803-69.377445 167.416513z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>
                      <el-form-item prop="password">
                        <input
                          type="password"
                          id="password"
                          maxlength="16"
                          @keyup.enter="handleLogin"
                          v-model="loginForm.password"
                          autocomplete="on"
                          placeholder="请输入密码"
                          class="form-control ui-input"
                        />
                      </el-form-item>
                    </div>
                    <div class="help-block"></div>
                  </div>
                  <div class="form-group remember"></div>
                  <div class="clearfix">
                    <a class="c-blue pull-left" @click="handleForgetPassword"
                      >忘记密码</a
                    >
                    <a class="c-blue pull-right" @click="handleRegister"
                      >立即注册&gt;</a
                    >
                  </div>

                  <el-form-item style="margin: 30px auto">
                    <el-button
                      style="width: 100%"
                      type="primary"
                      :loading="loading"
                      @click.native.prevent="handleLogin"
                      >登录</el-button
                    >
                  </el-form-item>
                </div>

                <div class="third-login">
                  <fieldset class="field-title text-center">
                    <legend class="text-center">使用第三方账号登录</legend>
                  </fieldset>
                  <div class="third-group">
                    <a
                      v-for="item in oauthList"
                      :key="item.address"
                      :href="`${item.address}&redirect_uri=${origin}/oauth/callback`"
                      target="_black"
                    >
                      <img
                        :src="
                          item.image_base_64 ||
                            `//cdn.w7.cc/web/resource/images/wechat/qqlogin.png`
                        "
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import { setSupport, SupportUrl } from "@/utils/support";

export default {
  name: "Login",
  data() {
    // 定义用户名校验规则
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    // 定义密码校验规则
    const validatePass = (rule, value, callback) => {
      if (value.length < 8) {
        callback(new Error("密码不能小于8位"));
      }
      if (value.length > 16) {
        callback(new Error("密码不能大于16位"));
      } else {
        callback();
      }
    };
    return {
      address: window.location.href,
      origin: window.location.origin,
      oauthList: [],
      loginForm: {
        // username: window.localStorage.userName,
        username: "",
        password: "",
        sso: "",
        sig: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      loading: false,
      pwdType: "password",
      dialogVisible: false,
      redirect: "/manage",
      Address: false
    };
  },
  created() {
    this.fetchOAuth();
    this.$store.commit("reset");
    // 判断当路由头中的redirect有且不为空的时候，将路由中的redirect信息给redirect
    if (this.$route.query.redirect && this.$route.query.redirect != "") {
      this.redirect = this.$route.query.redirect;
    }
    this.$store.dispatch("FedLogOut").then(() => {});
  },
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    fetchOAuth() {
      this.$store
        .dispatch("fetchOAuth")
        .then(res => {
          if (res && res.code == 200) {
            this.oauthList = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loginForm.sso = this.$route.query.sso;
          this.loginForm.sig = this.$route.query.sig;
          this.loading = true;
          this.$store
            .dispatch("Login", this.loginForm)
            .then(res => {
              this.$message({
                message: res.msg_show,
                type: "success"
              });
              this.loading = false;
              const str = this.redirect;
              // const storage= window.localStorage;
              // storage["userName"]=this.loginForm.username
              // console.log(storage.userName);
              // 登录判断
              if (
                // 如果在redirect中存在以下信息，就跳转到manage页面。
                str.indexOf("login") != -1 ||
                str.indexOf("register") != -1 ||
                str.indexOf("forgetPassword") != -1
              ) {
                this.$router.push("/manage");
              } else {
                // 否则就跳转到redirect存储的页面。
                this.$router.push(str);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 点击登录页面上的头，就给推一个登录的页面
    handleLogins() {
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath }
      });
    },
    handleQuickLogin() {
      this.$router.push({ name: "quick" });
    },
    // 定义重定向的路由，路由头中带过来的redirect存在，就把它给redirect
    getRedirect() {
      var redirect = this.$route.fullPath;
      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect;
      }
      // 判断redirect的页面是不是/manage/login，是则返回信息‘manage’，不是就直接返回redirect中的信息
      if (redirect == "/manage/login") {
        return "/manage";
      }
      return redirect;
    },
    // 跳转注册页面，并把重定向的参数带上。
    handleRegister() {
      this.$router.push({
        name: "register",
        query: { redirect: this.getRedirect() }
      });
    },
    // 忘记密码就跳转到忘记密码页面，带上redirect参数。
    handleForgetPassword() {
      this.$router.push({
        name: "forgetPassword",
        query: { redirect: this.$route.fullPath }
      });
    },
    dialogConfirm() {
      this.dialogVisible = false;
      setSupport(true);
      window.location.href = SupportUrl;
    },
    dialogCancel() {
      this.dialogVisible = false;
      setSupport(false);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/publicSubmit.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue